// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "aphrodite";

// components
import BaseComponent from "@cloudspire/legacy-resources/src/components/BaseComponent2";
import Text from "@cloudspire/legacy-resources/src/components/Text2";
import { Row, Col } from "@cloudspire/legacy-resources/src/components/Grid2";
import Item from "./Item";

type PropsType = {
  itemList: {
    label: string;
    to?: string;
  }[];
};

const styles = StyleSheet.create({
  separator: {
    color: "#9b9b9b",
  },
});

const Breadcrumb: React.FunctionComponent<PropsType> = (props) => {
  const { itemList } = props;
  const intl = useIntl();

  return (
    <BaseComponent
      role="navigation"
      title={intl.formatMessage({
        defaultMessage: "fil d'Ariane",
      })}
    >
      <Row
        type="inline"
        gutter={{ horizontal: 0.25, vertical: 0.5 }}
        role="list"
        flexWrap={true}
      >
        {itemList.map((item, index) => {
          return (
            <Col key={index} aria-level={index + 1} role="listitem">
              <Row type="inline" gutter={{ horizontal: 0.25, vertical: 0.5 }}>
                {index !== 0 && (
                  <Col>
                    <Text role="separator" style={styles.separator}>
                      {"/"}
                    </Text>
                  </Col>
                )}

                <Col>
                  <Item
                    to={item.to}
                    label={item.label}
                    current={index === itemList.length - 1}
                  />
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </BaseComponent>
  );
};

export default Breadcrumb;
